/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { WorkCreatePersonnelFileEntryDto } from '../models/work-create-personnel-file-entry-dto';
import { WorkPersonnelFileEntry } from '../models/work-personnel-file-entry';
import { WorkUpdatePersonnelFileEntryDto } from '../models/work-update-personnel-file-entry-dto';

@Injectable({ providedIn: 'root' })
export class WorkPersonnelFilesV2Service extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `personnelFilesV2ControllerFindByUserId()` */
  static readonly PersonnelFilesV2ControllerFindByUserIdPath = '/v2/personnel-files/byUser/{userId}';

  /**
   * Required permissions: personnelfiles:read, personnelfiles:admin, all:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `personnelFilesV2ControllerFindByUserId()` instead.
   *
   * This method doesn't expect any request body.
   */
  personnelFilesV2ControllerFindByUserId$Response(
    params: {
      userId: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkPersonnelFileEntry>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkPersonnelFilesV2Service.PersonnelFilesV2ControllerFindByUserIdPath, 'get');
    if (params) {
      rb.path('userId', params.userId, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkPersonnelFileEntry>>;
      })
    );
  }

  /**
   * Required permissions: personnelfiles:read, personnelfiles:admin, all:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `personnelFilesV2ControllerFindByUserId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  personnelFilesV2ControllerFindByUserId(
    params: {
      userId: number;
    },
    context?: HttpContext
  ): Observable<Array<WorkPersonnelFileEntry>> {
    return this.personnelFilesV2ControllerFindByUserId$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkPersonnelFileEntry>>): Array<WorkPersonnelFileEntry> => r.body)
    );
  }

  /** Path part for operation `personnelFilesV2ControllerFindOneById()` */
  static readonly PersonnelFilesV2ControllerFindOneByIdPath = '/v2/personnel-files/{id}';

  /**
   * Required permissions: personnelfiles:read, personnelfiles:admin, all:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `personnelFilesV2ControllerFindOneById()` instead.
   *
   * This method doesn't expect any request body.
   */
  personnelFilesV2ControllerFindOneById$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkPersonnelFileEntry>> {
    const rb = new RequestBuilder(this.rootUrl, WorkPersonnelFilesV2Service.PersonnelFilesV2ControllerFindOneByIdPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkPersonnelFileEntry>;
      })
    );
  }

  /**
   * Required permissions: personnelfiles:read, personnelfiles:admin, all:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `personnelFilesV2ControllerFindOneById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  personnelFilesV2ControllerFindOneById(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<WorkPersonnelFileEntry> {
    return this.personnelFilesV2ControllerFindOneById$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkPersonnelFileEntry>): WorkPersonnelFileEntry => r.body)
    );
  }

  /** Path part for operation `personnelFilesV2ControllerSoftDelete()` */
  static readonly PersonnelFilesV2ControllerSoftDeletePath = '/v2/personnel-files/{id}';

  /**
   * Required permissions: personnelfiles:delete, personnelfiles:admin, all:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `personnelFilesV2ControllerSoftDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  personnelFilesV2ControllerSoftDelete$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<void>> {
    const rb = new RequestBuilder(this.rootUrl, WorkPersonnelFilesV2Service.PersonnelFilesV2ControllerSoftDeletePath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'text', accept: '*/*', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Required permissions: personnelfiles:delete, personnelfiles:admin, all:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `personnelFilesV2ControllerSoftDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  personnelFilesV2ControllerSoftDelete(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<void> {
    return this.personnelFilesV2ControllerSoftDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `personnelFilesV2ControllerUpdate()` */
  static readonly PersonnelFilesV2ControllerUpdatePath = '/v2/personnel-files/{id}';

  /**
   * Required permissions: personnelfiles:update, personnelfiles:admin, all:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `personnelFilesV2ControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  personnelFilesV2ControllerUpdate$Response(
    params: {
      id: number;
      body: WorkUpdatePersonnelFileEntryDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<void>> {
    const rb = new RequestBuilder(this.rootUrl, WorkPersonnelFilesV2Service.PersonnelFilesV2ControllerUpdatePath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'text', accept: '*/*', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Required permissions: personnelfiles:update, personnelfiles:admin, all:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `personnelFilesV2ControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  personnelFilesV2ControllerUpdate(
    params: {
      id: number;
      body: WorkUpdatePersonnelFileEntryDto
    },
    context?: HttpContext
  ): Observable<void> {
    return this.personnelFilesV2ControllerUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `personnelFilesV2ControllerCreate()` */
  static readonly PersonnelFilesV2ControllerCreatePath = '/v2/personnel-files';

  /**
   * Required permissions: personnelfiles:create, personnelfiles:admin, all:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `personnelFilesV2ControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  personnelFilesV2ControllerCreate$Response(
    params: {
      body: WorkCreatePersonnelFileEntryDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkPersonnelFileEntry>> {
    const rb = new RequestBuilder(this.rootUrl, WorkPersonnelFilesV2Service.PersonnelFilesV2ControllerCreatePath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkPersonnelFileEntry>;
      })
    );
  }

  /**
   * Required permissions: personnelfiles:create, personnelfiles:admin, all:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `personnelFilesV2ControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  personnelFilesV2ControllerCreate(
    params: {
      body: WorkCreatePersonnelFileEntryDto
    },
    context?: HttpContext
  ): Observable<WorkPersonnelFileEntry> {
    return this.personnelFilesV2ControllerCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkPersonnelFileEntry>): WorkPersonnelFileEntry => r.body)
    );
  }

}
